import * as Fathom from "fathom-client"

window.addEventListener('turbo:load', () => {
  const gameStartButton = document.getElementById('started-a-game')
  const tournamentStartButtons = Array.from(
    document.getElementsByClassName('started-a-tournament')
  )
  const gameInviteButton = document.getElementById(
    'copied-game-invite-link'
  )
  const tournamentLink = document.getElementById(
    'copied-tournament-invite-link'
  )

  const zillowLink = document.getElementById(
    'zillow-link'
  )

  const offerLink = document.getElementById(
    'offer-link'
  )

  if (gameStartButton) {
    gameStartButton.addEventListener('click', () => {
      Fathom.trackGoal('FUMYKD5G', 0)
    })
  }

  tournamentStartButtons.forEach((button) => {
    button.addEventListener('click', () => {
      Fathom.trackGoal('5C8M6S3W', 0)
    })
  })

  if (gameInviteButton) {
    gameInviteButton.addEventListener('click', () => {
      Fathom.trackGoal('XSXN9EFF', 0)
    })
  }

  if (tournamentLink) {
    tournamentLink.addEventListener('click', () => {
      Fathom.trackGoal('2UPG4XSR', 0)
    })
  }

  if (zillowLink) {
    zillowLink.addEventListener('click', () => {
      Fathom.trackGoal('UQMFV9PX', 0)
    })
  }

  if (offerLink) {
    offerLink.addEventListener('click', () => {
      Fathom.trackGoal('GVEALBUF', 0)
    })
  }
})
